import { Component } from "@angular/core";
import { MantenimientosService } from "src/app/services/mantenimientos.service";

@Component({
	selector: "app-sin-opciones",
	templateUrl: "./sin-opciones.component.html",
	styleUrls: ["./sin-opciones.component.scss"]
})
export class SinOpcionesComponent {
  public isLoading: boolean = false;
	constructor(
		private readonly _mantenimientosService: MantenimientosService
	) {}

	exit() {
    this.isLoading = true;
		this._mantenimientosService.logoutService().subscribe(() => {
			window.location.href =
				"https://www.bancolombia.com/personas/alternativas-financieras/negociar-deuda";
		});
	}
}
